import { FileText, Files } from "lucide-react";
import React from "react";
import { CreateModeOption } from "./CreateModeOption";
import { translate } from "@/helper/translate";

interface CreateModeSelectorProps {
    createMode: "new" | "update";
    setCreateMode: (mode: "new" | "update") => void;
}

export const CreateModeSelector: React.FC<CreateModeSelectorProps> = ({
    createMode,
    setCreateMode,
}) => (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <CreateModeOption
            icon={Files}
            title="Create as New Resume"
            description={`Keep the selected resume and create a brand new ${translate("optimised")} resume`}
            isSelected={createMode === "new"}
            onClick={() => setCreateMode("new")}
        />
        <CreateModeOption
            icon={FileText}
            title="Update Existing Resume"
            description={`Replace the selected resume with the new ${translate("optimised")} resume`}
            isSelected={createMode === "update"}
            onClick={() => setCreateMode("update")}
        />
    </div>
);
